import { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import useBackLinkRedirect from "../../../Components/Custom/useBackLinkRedirect";
import { getKycOcrApiReducer, getKycPanOcrApiReducer } from "../../../Redux/Reducers/KycReducer";
import OcrPassport from "./OcrPassport";
import VerifyAadhar from "./VerifyAadhar";
import Verifydrivinglicense from "./Verifydrivinglicense";
import VerifyPANCard from "./Verifypancard";

const Aadhar = () => <VerifyAadhar />;
const VerifyEPFO = () => <h1>EPF Account Verification</h1>;
const handlePANCard = () => <VerifyPANCard />;
const handleResidentialAddress = () => <h1>Residential Address Verification</h1>;
const handleDrivingLicense = () => <Verifydrivinglicense />;
const handlePassport = () => <OcrPassport />;
const handleVisa = () => <h1>Visa Verification</h1>;
const handleNRIC = () => <h1>NRIC Verification</h1>;
const handleBirthCertificate = () => <h1>Birth Certificate Verification</h1>;


// Map document types to components
const labelToFunctionMap = {
  "aadhaar": Aadhar,
  "epf-account": VerifyEPFO,
  "pan-card": handlePANCard,
  "residential-address": handleResidentialAddress,
  "driving-license": handleDrivingLicense,
  passport: handlePassport,
  visa: handleVisa,
  nric: handleNRIC,
  "birth-certificate": handleBirthCertificate,
};

const VerifyDocs = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const lastNavigationRef = useRef(null);
  const [searchParams] = useSearchParams();

  const { redirectToEnterprise } = useBackLinkRedirect();
  const accessToken = localStorage.getItem("objectId");
  // const previousPath = usePreviousPath()
  const previousPath = location.state?.from || sessionStorage.getItem('previousPath');

  // Get docType from state

  const GetAadharData = useSelector((state) => state?.Kyc?.verifiedGetData);
  const GetPanData = useSelector((state) => state?.Kyc?.verifiedGetData);
  const getImages = useSelector((state) => state?.Kyc?.getPanData);
  const latestPanImage = useMemo(() => {
    if (!Array.isArray(getImages) || getImages.length === 0) return null;

    return [...getImages].sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    )[0];
  }, [getImages]);

  const hasAadharData =
    GetAadharData?.statusCode === 200 &&
    GetAadharData?.data &&
    Object.keys(GetAadharData.data).length > 0;

  const hasPanData =
    GetPanData?.statusCode === 200 &&
    GetPanData?.data &&
    Object.keys(GetPanData.data).length > 0;

  const isAadharVerified = Boolean(
    hasAadharData &&
    GetAadharData?.data?.aadharData?.masked_id &&
    GetAadharData?.data?.aadharData?.masked_id !== "Not verified Yet"
  );



  const isPanVerified = Boolean(
    hasPanData &&
    GetPanData?.data?.panData?.pan_number &&
    GetPanData?.data?.panData !== "Not verified Yet"
  )


  // console.log("isAadharVerified:", isAadharVerified, isPanVerified);


  const currentDoc = location.state?.docType || localStorage.getItem("docType");

  const doc = currentDoc;

  useEffect(() => {
    dispatch(getKycOcrApiReducer());
    dispatch(getKycPanOcrApiReducer());
  }, [dispatch]);

  useEffect(() => {
    if (GetAadharData === undefined || GetPanData === undefined) return;

    const normalizedDoc = currentDoc?.toLowerCase();
    const bothVerified = isAadharVerified && isPanVerified;

    if (bothVerified) {
      if (lastNavigationRef.current !== 'done') {
        lastNavigationRef.current = 'done';
        console.log('VerifyDocs – both documents verified, redirecting to enterprise');
        redirectToEnterprise();
      }
      return;
    }

    if (isAadharVerified) {
      if (normalizedDoc === 'pan-card' || normalizedDoc === 'pan') return;

      if (lastNavigationRef.current !== 'goto-pan') {
        lastNavigationRef.current = 'goto-pan';
        console.log('VerifyDocs – Aadhaar done, navigating to PAN');
        localStorage.setItem('docType', 'pan-card');
        navigate('/verify-docs', { state: { docType: 'pan-card' }, replace: true });
      }
      return;
    }

    if (normalizedDoc !== 'aadhaar' && lastNavigationRef.current !== 'goto-aadhaar') {
      lastNavigationRef.current = 'goto-aadhaar';
      console.log('VerifyDocs – navigating to Aadhaar');
      localStorage.setItem('docType', 'Aadhaar');
      navigate('/verify-docs', { state: { docType: 'Aadhaar' }, replace: true });
    }
  }, [
    isAadharVerified,
    isPanVerified,
    currentDoc,
    navigate,
    redirectToEnterprise,
    GetAadharData,
    GetPanData,
  ]);

  if (!doc) {

    return
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ minHeight: '100vh' }}>
      <h1>Missing document type.</h1>
    </div>
  }

  localStorage.setItem("docType", doc);

  const CustomHandler = labelToFunctionMap[doc.toLowerCase()];

  return CustomHandler ? (
    <CustomHandler />
  ) : (
    <h1>Error: No matching handler found for "{doc}".</h1>
  );
};

export default VerifyDocs;
